import classNames from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TdsLogoEn from '@/assets/images/public/TDS-bugly-pre-en.react.svg';
import i18n from '@/i18n';
import { CustomerServicePopover } from './customer-service-popover';
import style from './index.module.scss';
import TdsLogo from './logo.svg';

enum TdsItemKey {
  TencentService,
  DocCenter,
  BuglyOverseas,
  CustomerService,
}

enum Env {
  TEST,
  PROD,
}

const NAVIGATION_URL: Record<TdsItemKey, Record<Env, string>> = {
  [TdsItemKey.TencentService]: {
    [Env.TEST]: 'https://t.tds.qq.com/',
    [Env.PROD]: 'https://tds.qq.com',
  },
  [TdsItemKey.DocCenter]: {
    [Env.TEST]: 'https://t.bugly.tds.qq.com/docs/',
    [Env.PROD]: 'https://bugly.tds.qq.com/docs/',
  },
  [TdsItemKey.BuglyOverseas]: {
    [Env.TEST]: 'https://t.bugly.tds.tencent.com/v2/index/main',
    [Env.PROD]: 'https://bugly.tds.tencent.com/v2/index/main',
  },
  [TdsItemKey.CustomerService]: {
    [Env.TEST]: '',
    [Env.PROD]: '',
  },
};

interface NavItem {
  title: string;
  key: TdsItemKey;
}

// 专业版：腾讯端服务、Bugly海外版、文档中心、客服
const PRO_NAVIGATION: NavItem[] = [
  { title: i18n.t('腾讯端服务'), key: TdsItemKey.TencentService },
  { title: i18n.t('Bugly海外版'), key: TdsItemKey.BuglyOverseas },
  { title: i18n.t('文档中心'), key: TdsItemKey.DocCenter },
  { title: i18n.t('客服'), key: TdsItemKey.CustomerService },
];

export interface TdsCustomNavigationProps {
  activeMenu?: TdsItemKey;
  isProd: boolean;
  isMobile?: boolean;
}

export { TdsItemKey };

export const TdsCustomNavigation: FC<TdsCustomNavigationProps> = (props) => {
  const {
    isProd,
    isMobile = false,
    activeMenu,
  } = props;

  const { t, i18n: i18nInstance } = useTranslation();
  const [scroll, setScroll] = useState(window.scrollY !== 0);
  const [menuOpen, setMenuOpen] = useState(false);
  const env = isProd ? Env.PROD : Env.TEST;
  const isEnLocale = i18nInstance.language === 'en-US';

  const handleOpenUrl = (url: string) => {
    if (!url || url === '#') return;
    window.open(url, '_blank');
  };

  useEffect(() => {
    const onScroll = () => setScroll(window.scrollY !== 0);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={classNames(style.tdsNavigation, style.tdsNavigationLight)}
      style={{
        backgroundColor: scroll || menuOpen ? '#fff' : 'transparent',
        boxShadow: scroll || menuOpen ? '0px 1px 4px 0px rgba(42, 58, 134, 0.15)' : 'none',
      }}
    >
      <div className={style.tdsNavigationContent}>
        <img
          src={isEnLocale ? TdsLogoEn : TdsLogo}
          width={isEnLocale ? 156 : 162}
          height={44}
          alt={t('Bugly 专业版')}
          className={style.tdsNavigationLogo}
        />
        {!isMobile ? (
          <div className={style.tdsNavigationRow}>
            {PRO_NAVIGATION.map((item) => {
              if (item.key === TdsItemKey.CustomerService) {
                return (
                  <CustomerServicePopover key={item.key}>
                    <a
                      className={classNames(
                        style.tdsNavigationContentItem,
                        item.key === activeMenu ? style.tdsNavigationContentItemActive : '',
                      )}
                    >
                      {item.title}
                    </a>
                  </CustomerServicePopover>
                );
              }
              return (
                <a
                  key={item.key}
                  onClick={() => handleOpenUrl(NAVIGATION_URL[item.key][env])}
                  className={classNames(
                    style.tdsNavigationContentItem,
                    item.key === activeMenu ? style.tdsNavigationContentItemActive : '',
                  )}
                >
                  {item.title}
                </a>
              );
            })}
          </div>
        ) : (
          <>
            <div
              className={style.tdsNavigationMenuBtn}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6H21M3 12H21M3 18H21" stroke="#1E304A" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            {menuOpen && (
              <div className={style.tdsNavigationDropdownContainer}>
                {PRO_NAVIGATION.map(item => (
                  <a
                    className={style.tdsNavigationDropdownItem}
                    key={item.key}
                    onClick={() => {
                      handleOpenUrl(NAVIGATION_URL[item.key][env]);
                      setMenuOpen(false);
                    }}
                  >
                    <div className={style.tdsNavigationDropdownItemTitle}>{item.title}</div>
                  </a>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
